<div class="signature-input">
    <fa-icon class="status" [icon]="hasValue ? 'check' : 'xmark'"
        [style]="{'color': hasValue ? 'green' : 'red'}"></fa-icon>
    <button type="button" class="toggle-preview cursor-pointer" *ngIf="hasValue" (click)="$event.stopPropagation(); toggleDisplayPreview()">
        {{displayPreview ? '-' : '+'}}
    </button>
    <app-big-button class="big_btn big_btn-resp fullWidth"
        [icon]="icon"
        [label]="labelKey | translate"
        [description]="description?.length ? (description | translate) : undefined"
        [selected]="hasValue"
        [responsive]="true"
        (clicked)="openSignatureModal()">
    </app-big-button>
    <div class="preview-box" *ngIf="hasValue">
        <div class="signature-preview" *ngIf="displayPreview" [innerHTML]="sanitizedValue"></div>
    </div>
</div>